document.addEventListener('turbolinks:load', function () {
  const exec_sum = document.querySelector('#executive-summary')
  const form = document.querySelector('#summarized-text form')
  if (exec_sum && exec_sum.classList.contains('plus') && !exec_sum.classList.contains('micro-sum')) {
    var requestMade
    if (form && !requestMade) {
      requestMade = true
      document.querySelector('#executive-summary .preloader-wrapper')?.classList.remove('hide')
      document.querySelector('#executive-summary .p4')?.classList.remove('hide')
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
    }
  }
  const generateSummaryButton = document.querySelector('#generate-summary-btn')
  if (generateSummaryButton) {
    generateSummaryButton.addEventListener('click', () => {
      if (form) {
        document.querySelector('#executive-summary .preloader-wrapper').classList.remove('hide')
        document.querySelector('#executive-summary .p4')?.classList.remove('hide')
        document.querySelector('#micro-teaser').classList.add('hide')
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
      }
    })
  }
})